import { render, staticRenderFns } from "./SafetyCheck.vue?vue&type=template&id=0716f671&scoped=true&"
import script from "./SafetyCheck.vue?vue&type=script&lang=js&"
export * from "./SafetyCheck.vue?vue&type=script&lang=js&"
import style0 from "./SafetyCheck.vue?vue&type=style&index=0&id=0716f671&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0716f671",
  null
  
)

export default component.exports